module.exports = __webpack_public_path__ + "ico_trans_atq.png";